import { useEffect, useState } from 'react'
import { onAuthStateChanged, type User } from 'firebase/auth'
import { auth } from 'src/firebase/firebase'

const useFirebaseAuthentication = () => {
    const [authUser, setAuthUser] = useState<string | User>('loading')

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, authUser => setAuthUser(authUser!))
        return () => unsubscribe()
    }, [])

    return authUser
}

export default useFirebaseAuthentication
